<!--
@Author: Tom Voorneveld <tom>
@Date:   2017-11-23T10:39:11+01:00
@Email:  tom@lorinthe.com
@Project: Lorinthe - Slides with the Commercial Services of Lorinthe
@Last modified by:   tom
@Last modified time: 2018-02-08T21:18:49+01:00
@Copyright: (c) copyright Lorinthe BV, all rights reserved
-->

<template lang="html">
  <section id="services-carousel">
    <b-jumbotron
      bg-variant="secondary"
      class="header"
    >
      <!-- :header="$t('services.title')"
      :lead="$t('services.payload')" -->
      <b-container>
        <b-row>
          <div class="col-md-8 offset-md-2">
            <b-carousel id="carousel-panel"
                        v-model="slide"
                        class="d-block mx-auto"
                        fade
                        controls
                        indicators
                        background="#a6894c"
                        :interval="4000"
                        img-width="1200"
                        img-height="600"
                        @sliding-start="onSlideStart"
                        @sliding-end="onSlideEnd"
            >
              <!-- one link for all to services page -->
              <router-link :to="{name:'Services'}">
                <!-- Text slides with image -->
                <!-- because wrapping inside a <b-carousel-slide> does not work: hardcode the expanded template -->

                <div v-for="f in nrSlides"
                     :key="f"
                     class="carousel-item"
                     role="listitem"
                >
                  <!-- show the carousel service slides, first one never lazy to force size -->
                  <lzimg
                    fluid-grow
                    block
                    width="1200"
                    height="600"
                    :no-lazy="f===1"
                    :src="assetUrl('img/services/'+ $t('services.' + f + '.img'))"
                  />
                  <!-- blanksrc="@/assets/img/services/blank.gif" -->
                  <div class="carousel-caption">
                    <h4>{{ $t('services.' + f + '.title') }}</h4>
                    <p>{{ $t('services.' + f + '.caption') }}</p>
                  </div>
                </div>
              </router-link>
            </b-carousel>
          </div>
        </b-row>
      </b-container>
    </b-jumbotron>
  </section>
</template>

<script>

import invokeScrollEvent from '@/lib/helpers/scrollPlugin'

export default {
  data () {
    return {
      slide: 0,
      nrSlides: 4, // Number of Slides in the Caroussel
      nrScrolls: 1
    }
  },
  methods: {
    onSlideStart () {
      // for lazy loading, we invoke scroll event for each slide once
      if (this.nrScrolls <= this.nrSlides) {
        // we did not lazy load all slides yet
        invokeScrollEvent('Slide ' + this.nrScrolls, 10)
        this.nrScrolls++
      }
    },
    onSlideEnd () {
      //
    }
  }
}

</script>

<style lang="scss">

  @import "../../assets/style/theme.scss";

    #services-carousel .jumbotron {
      padding: 0 !important;
    }

  @media (min-width:1200px) {
    // we can show next/prev button next to slides on wide screen
    #services-carousel {
      .carousel-control-next {
        right: -110px;
      }
      .carousel-control-prev {
        left: -110px;
      }
    }
  }

  #services-carousel {
    padding-bottom: 0;
    .carousel {
      // on wide screens we like to keep the carousel not too large
      // note the classes class="d-block mx-auto" on the <b-carousel ... >
      max-width: 1110px;
      border: 1px solid $secondary;
      text-shadow: 2px 2px 4px #333;
      .carousel-item {
        min-height: 180px; // to avoid starting too small and screen flash while loading first image
      }
      .carousel-caption {
        left: 0;
        right: 0;
        bottom: 0;
        padding-top: 80px;

        // shadow under the text / caption
        /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#4c4c4c+0,131313+100&0+0,0.71+100 */
        background: -moz-linear-gradient(top, rgba(76,76,76,0) 0%, rgba(19,19,19,0.71) 100%); /* FF3.6-15 */
        background: -webkit-linear-gradient(top, rgba(76,76,76,0) 0%,rgba(19,19,19,0.71) 100%); /* Chrome10-25,Safari5.1-6 */
        background: linear-gradient(to bottom, rgba(76,76,76,0) 0%,rgba(19,19,19,0.71) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
        filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#004c4c4c', endColorstr='#b5131313',GradientType=0 ); /* IE6-9 */

      }
      .carousel-indicators {
        bottom: 0;
      }
    }
  }
</style>
